/** The Maker portal's pages, in the sidebar's order. `icon` is an 18×18 stroke path. */
export const NAV_ITEMS = [
  { path: "/", label: "Monitoring", icon: "M2.5 9.5h3l2-5 3 9 2-4h3" },
  { path: "/rebalancing", label: "Rebalancing", icon: "M3 6h11.5l-3-3M15 12H3.5l3 3" },
  { path: "/limits", label: "Limits", icon: "M2.5 13.5a6.5 6.5 0 0 1 13 0M9 13.5l3.2-4.2M4.4 8.9l1 .8M9 7v1.3M13.6 8.9l-1 .8" },
  { path: "/pairs", label: "Pairs", icon: "M2.5 9a5 5 0 1 0 10 0a5 5 0 1 0-10 0M9.25 4.32a5 5 0 1 1 0 9.36" },
  {
    path: "/treasury",
    label: "Treasury",
    icon: "M3 5h11.5a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-11A1.5 1.5 0 0 1 2 13.5V4.5A1.5 1.5 0 0 1 3.5 3H13v2M12 10h.5",
  },
  {
    path: "/executor",
    label: "Executor",
    icon: "M6.5 5h5A1.5 1.5 0 0 1 13 6.5v5a1.5 1.5 0 0 1-1.5 1.5h-5A1.5 1.5 0 0 1 5 11.5v-5A1.5 1.5 0 0 1 6.5 5zM7.5 2.5V5M10.5 2.5V5M7.5 13v2.5M10.5 13v2.5M2.5 7.5H5M2.5 10.5H5M13 7.5h2.5M13 10.5h2.5",
  },
  { path: "/integrations", label: "Integrations", icon: "M6 3H3v4h3M12 11h3v4h-3M6 5h6v8H6z" },
  { path: "/order-history", label: "Order history", icon: "M6.5 5h8.5M6.5 9h8.5M6.5 13h8.5M3 5h.5M3 9h.5M3 13h.5" },
  { path: "/notifications", label: "Notifications", icon: "M4.5 12.5V8a4.5 4.5 0 0 1 9 0v4.5l1.5 1.5h-12zM7.5 15.5a1.5 1.5 0 0 0 3 0" },
  { path: "/docs", label: "API reference", icon: "M6.5 5L3 9l3.5 4M11.5 5L15 9l-3.5 4" },
] as const;
